<template>
  <v-container fluid>
    <h1 class="d-flex">
      <v-icon left>
        fal fa-fw fa-fax
      </v-icon>
      New Fax Contact
    </h1>

    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-text>
          <fax-contact-form :form="form">
          </fax-contact-form>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Create
          </v-btn>
          <v-btn @click.prevent="$router.back()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import faxService from '../../../services/faxService';
import FaxContactForm from '../library/components/FaxContactForm';
import DOMPurify from 'dompurify';

export default {
  components: {FaxContactForm},
  data() {
    return {
      form: new Form(faxService.getFormFields())
    }
  },
  methods: {
    submit() {
      faxService.createContact(this.form)
        .then(() => {
          this.$router.push({name: 'admin.fax_contacts.index'});
        })
        .catch(err => {
          this.$toast.error(DOMPurify.sanitize(err.response.data.message));
        })
    }
  }
}
</script>
